import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../layouts/AppLayout.css'; // Reusing AppLayout styles for now, or we can move specific styles here

interface UserMenuProps {
    user: { first_name: string; last_name: string } | null;
    onLogout: () => void;
    variant?: 'light' | 'dark'; // light for landing, dark for chat navbar
}

const UserMenu: React.FC<UserMenuProps> = ({ user, onLogout, variant = 'light' }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!user) return null;

    const textColorClass = variant === 'dark' ? 'text-white' : 'text-dark';
    const btnHoverClass = variant === 'dark' ? 'btn-hover-dark' : 'btn-hover-light';

    return (
        <div className="user-menu-container" ref={menuRef}>
            <button
                className={`user-menu-btn ${textColorClass} ${btnHoverClass} ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="user-avatar">
                    {user.first_name.charAt(0).toUpperCase()}
                </div>
                <span className="user-name d-none d-md-inline">
                    {user.first_name} {user.last_name}
                </span>
                <span className="dropdown-arrow"><i className="bi bi-chevron-down"></i></span>
            </button>

            {isOpen && (
                <div className="user-dropdown-menu">
                    <div className="dropdown-header-info">
                        <strong>{user.first_name} {user.last_name}</strong>
                    </div>
                    <div className="dropdown-divider"></div>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            navigate(`/${i18n.language}/dashboard`);
                        }}
                        className="dropdown-item-custom"
                    >
                        <span className="icon"><i className="bi bi-speedometer2 me-2"></i></span> {t('nav.dashboard', 'Tableau de Bord')}
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            navigate(`/${i18n.language}/profile`);
                        }}
                        className="dropdown-item-custom"
                    >
                        <span className="icon"><i className="bi bi-person me-2"></i></span> {t('nav.account', 'Mon Compte')}
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            onLogout();
                        }}
                        className="dropdown-item-custom logout"
                    >
                        <span className="icon"><i className="bi bi-box-arrow-right me-2"></i></span> {t('landing.logout', 'Déconnexion')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
